import React from 'react'
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const blue = '#255A8D';

const styles = {
  root: {
    fontSize: '75%',
    color: blue,
    height: 56,
    //bug not working
    /*'&$disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      background: 'white'
    }*/
  }
};

class StyledOutlinedButton extends React.PureComponent {
  render() {
    const { classes, children, className, ...other } = this.props;
    return (
      <Button
        variant="outlined"
        classes={{
        root: classNames(classes.root, className),
        disabled: classNames(classes.disabled, className)
      }} {...other}>
        {children || 'class names'}
      </Button>
    );
  }

}

export default withStyles(styles)(StyledOutlinedButton);



// WEBPACK FOOTER //
// ./src/js/components/inputs/StyledOutlinedButton.js